import type {
    IProjectListResponse, IRightListRequest,
} from '@/types';
import { container } from '@eureka/services';
import type { ICoreDataWrapper } from '@eureka/services/src/exception';
import type { ISolutionListResponse } from '@eureka/solution-card/src/types';
/**
 *
 * @returns 项目列表
 */
export function getProjectList() {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/list`
    return container.RnDHttp.get<ICoreDataWrapper<IProjectListResponse>>({
        url,
    }).then(res => {
        return res.data
    })
}

/**
 *
 * @param pinned_project_id
 * @returns 置顶
 */
export function pinnedProject(pinned_project_id: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/${pinned_project_id}/pinned`
    return container.RnDHttp.put<ICoreDataWrapper<null>>({
        url,
    }).then(res => {
        return res
    })
}

/**
 *
 * @param unpinned_project_id
 * @returns 取消置顶
 */
export function unPinnedProject(unpinned_project_id: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/${unpinned_project_id}/unpinned`
    return container.RnDHttp.put<ICoreDataWrapper<null>>({
        url,
    }).then(res => {
        return res
    })
}

/**
 *
 * @param project_id
 * @returns 删除项目
 */
export function deleteProject(id: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/${id}`
    return container.RnDHttp.delete<ICoreDataWrapper<null>>({
        url,
    }).then(res => {
        return res
    })
}

/**
 * @params IRightListRequestData
 * @returns 右侧列表 IRightListResponse
 */
export function getRightList(data: IRightListRequest) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/right-list`
    return container.RnDHttp.post<ICoreDataWrapper<ISolutionListResponse>>({
        url,
        data,
    }).then(res => {
        return res.data
    })
}

export function trackViewProjectAPI(id: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/tracking/add`
    return container.RnDHttp.post<ICoreDataWrapper<boolean>>({
        url,
        data: {
            module_type: 'EUREKA',
            event_type: 'SS Project',
            source_type: 'view',
            other_param: id,
        },
    }).then(res => {
        return res.data
    })
}
